module.exports = __webpack_public_path__ + "static/media/Mascot_vic_jpg.7c676cfa.jpg";